import { useState } from "react";
import { Flex, Form } from "antd";
import { observer } from "mobx-react-lite";

import { DocUploadedResponse, FILE_TYPE_ENUM, NOTIFICATION_TYPE_ENUM } from "interfaces";
import { useStores } from "stores";
import { parseErrorMessage } from "utils";
import { uploadBidFile } from "services";
import { useNotificationContext } from "providers";
import { CustomButton, FileInput, UploadedFileDisplay } from "ui";

export const AddDocumentModal = observer(() => {
  const { actionModals, bidCard } = useStores();
  const { openNotification } = useNotificationContext();

  const [loading, setLoading] = useState(false);

  const [uploadedFiles, setUploadedFile] = useState<DocUploadedResponse[]>([]);

  const addRuleFileHandler = async () => {
    await uploadBidFile(
      { requestId: bidCard.bid.id },
      { docIds: uploadedFiles.map((item) => item.id) }
    )
      .then(() => {
        handleCloseModal();
        setTimeout(() => {
          bidCard.updateCardById(bidCard.bid.id);
          setLoading(false);
        }, 1500);
        openNotification({
          message: "Документ сохранен",
          type: NOTIFICATION_TYPE_ENUM.SUCCESS,
        });
      })
      .catch((e) => {
        openNotification({
          type: NOTIFICATION_TYPE_ENUM.ERROR,
          description: parseErrorMessage(e),
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleCloseModal = () => {
    actionModals.closeAll();
  };

  const handleUploadFile = async (responseUpload: DocUploadedResponse[]) => {
    if (responseUpload && responseUpload.length > 0) {
      const newUploadedFiles = [...uploadedFiles, ...responseUpload];
      setUploadedFile(newUploadedFiles);
    }
  };

  const handleRemoveDocument = (file: DocUploadedResponse) => {
    if (loading) return;
    const newUploadedFiles = uploadedFiles.filter((item) => item.id !== file.id);
    setUploadedFile(newUploadedFiles);
  };

  return (
    <Flex vertical gap="large">
      <>
        {uploadedFiles.length > 0 ? (
          uploadedFiles.map((file) => (
            <UploadedFileDisplay
              fileName={file.originalFilename}
              onRemove={() => handleRemoveDocument(file)}
              tooltip="Заменить документ"
              key={file.id}
            />
          ))
        ) : (
          <Flex>
            <FileInput
              blockTitle="Дополнительный документ"
              fileType={FILE_TYPE_ENUM.ADDITIONAL_DOC}
              onUpload={handleUploadFile}
              className="full-width"
              multiple
            />
          </Flex>
        )}
      </>
      <Form.Item>
        <Flex gap="large">
          <CustomButton
            htmlType="button"
            disabled={loading || uploadedFiles.length === 0}
            loading={loading}
            onClick={addRuleFileHandler}
          >
            Сохранить
          </CustomButton>
          <CustomButton
            htmlType="button"
            disabled={loading}
            loading={loading}
            type="default"
            onClick={handleCloseModal}
          >
            Отмена
          </CustomButton>
        </Flex>
      </Form.Item>
    </Flex>
  );
});
